import React from "react"
import { useTranslation } from "react-i18next"

import { SelectOption } from "shared/types/Select"
import { Select } from "shared/ui/input/select/select/Select"

interface ProjectPhaseFilterInputProps {
  options?: SelectOption<string>[]
  className?: string
  disabled?: boolean
}

export const ProjectPhaseFilterInput = React.memo(
  ({ options, disabled, className }: ProjectPhaseFilterInputProps) => {
    const { t } = useTranslation()

    return (
      <Select.Root
        name="projectPhase"
        label={t("Project.phase")}
        data-testid="project-phase-filter"
        className={className}
        disabled={disabled}
        elevated
      >
        <Select.Label />
        <Select.Input
          options={options}
          isMulti
          isClearable
          placeholder={t("General.Select")}
        />
      </Select.Root>
    )
  }
)
